import React from 'react';
import PanelsDisplayTable from 'app-ui-componentlibrary/dist/componentLibrary/layout/PanelsDisplayTable';
import _ from 'lodash';
import {Header} from 'semantic-ui-react';
import {connectWithCore} from 'framework/hocs';
import {getPartName} from 'common/utils';

export const PrescoresSummary = ({
  id,
  refItems,
  prescores,
  activityLabel,
  activityScoreLabel,
}) => {
  const prescoresTable = {
    columnHeaders: [activityLabel, activityScoreLabel],
    columnKeys: ['activityName', 'score'],
    columnWidths: [6, 3],
  };

  let rows = [];
  _.map(prescores, (ps) => {
    const activityName = getPartName(ps.itemCode, refItems);
    rows.push({activityName: activityName, score: _.round(ps.score, 2).toFixed(2)});
  });

  return _.size(rows) > 0 ? (
    <React.Fragment>
      <Header as="h3" id={id || ''}>
        Pre-score Summary
      </Header>
      <PanelsDisplayTable
        summary={'Pre-scores'}
        columnHeaders={prescoresTable.columnHeaders}
        columnKeys={prescoresTable.columnKeys}
        columnWidths={prescoresTable.columnWidths}
        rows={rows}
      />
    </React.Fragment>
  ) : null;
};

export default connectWithCore(PrescoresSummary);
